import { defineMessages } from 'react-intl';

export const messages: {
	interactiveVideoTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	interactiveVideoDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	documentationTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	documentationDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createContentTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createContentDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createContentWithAITitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createContentWithAIDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nextButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exploreButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dismiss: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	progressIndicator: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	interactiveVideoTitle: {
		defaultMessage: 'Record & share videos',
		description: 'Title for the first step highlighting interactive video content',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title',
	},
	interactiveVideoDescription: {
		defaultMessage:
			'Create video messages using Loom to talk through updates, feedback, or upcoming work.',
		description: 'Description for the first step highlighting interactive video content',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description',
	},
	documentationTitle: {
		defaultMessage: 'Turn ideas into docs instantly with AI',
		description: 'Title for the second step about adding documentation and videos',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title',
	},
	documentationDescription: {
		defaultMessage:
			'Create docs directly in Jira to capture work, strategy, and more — with AI doing the heavy lifting.',
		description: 'Description for the second step about adding documentation and videos',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description',
	},
	createContentTitle: {
		defaultMessage: "Now it's your turn!",
		description: 'Title for the third step about creating content directly',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title',
	},
	createContentDescription: {
		defaultMessage: 'Try Keep adding content to your page. You can type /ai to prompt AI.',
		description: 'Description for the third step about creating content directly',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description',
	},
	createContentWithAITitle: {
		defaultMessage: "Now it's your turn!",
		description: 'Now it is your turn to add content to your page.',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.title',
	},
	createContentWithAIDescription: {
		defaultMessage:
			'Try summarizing or generating more content with AI. You can always come back to this panel.',
		description: 'Description for the third step when AI button is visible',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.description',
	},
	nextButton: {
		defaultMessage: 'Next',
		description: 'Button indicating the next step in the TWC spotlight tour',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next',
	},
	exploreButton: {
		defaultMessage: 'Explore',
		description: 'Button indicating exploration action in the TWC spotlight tour',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.navigation.explore',
	},
	dismiss: {
		defaultMessage: 'Dismiss',
		description: 'Button to dismiss the TWC spotlight tour',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip',
	},
	progressIndicator: {
		defaultMessage: '{currentStep}/{totalSteps}',
		description:
			'Progress indicator showing current step and total steps in the TWC spotlight tour',
		id: 'growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress',
	},
});
